import React from 'react';
import './AboutSection.scss';

const AboutSection = () => {
  return (
    <div className="about-section">
      <h2>Devi Jewellers</h2>
      <p>
        Year 1938, when our forefathers started this small jewellery business in a small room, 
        is still reigning over the sector maintaining the same trust among all our customers.
      </p>
    </div>
  );
};

export default AboutSection;
